module.exports = __webpack_public_path__ + "static/media/titleGrid.d4dadb53.jpg";